var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "24px",
    viewBox: "0 0 23 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BB317850-DCB6-4394-9EE7-2C223C53EB6A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.17660044,7.82445141 C5.54348786,7.82445141 6.68256071,8.42633229 7.4419426,9.40438871 L14.6560706,4.58934169 C14.5801325,4.43887147 14.5801325,4.28840125 14.5801325,4.13793103 C14.5801325,1.88087774 16.4785872,0 18.7567329,0 C21.1108168,0 22.9333333,1.88087774 22.9333333,4.13793103 C22.9333333,6.39498433 21.1108168,8.27586207 18.7567329,8.27586207 C17.3139073,8.27586207 16.0229581,7.52351097 15.2635762,6.39498433 L8.27726269,11.2100313 C8.35320088,11.4357367 8.35320088,11.7366771 8.35320088,11.9623824 C8.35320088,12.2633229 8.35320088,12.4890282 8.27726269,12.7899687 L15.2635762,17.5297806 C16.0229581,16.4012539 17.3139073,15.6489028 18.7567329,15.6489028 C21.1108168,15.6489028 22.9333333,17.5297806 22.9333333,19.862069 C22.9333333,22.1191223 21.1108168,24 18.7567329,24 C16.4785872,24 14.5801325,22.1191223 14.5801325,19.862069 C14.5801325,19.7115987 14.5801325,19.5611285 14.6560706,19.4106583 L7.4419426,14.5203762 C6.68256071,15.4984326 5.54348786,16.1003135 4.17660044,16.1003135 C1.89845475,16.1003135 3.01980663e-14,14.2946708 3.01980663e-14,11.9623824 C3.01980663e-14,9.70532915 1.89845475,7.82445141 4.17660044,7.82445141 Z M18.7567329,17.6050157 C17.5417219,17.6050157 16.5545254,18.5830721 16.5545254,19.862069 C16.5545254,21.0658307 17.5417219,22.0438871 18.7567329,22.0438871 C20.0476821,22.0438871 21.0348786,21.0658307 21.0348786,19.862069 C21.0348786,18.5830721 20.0476821,17.6050157 18.7567329,17.6050157 Z M18.7567329,1.88087774 C17.5417219,1.88087774 16.5545254,2.93416928 16.5545254,4.13793103 C16.5545254,5.34169279 17.5417219,6.39498433 18.7567329,6.39498433 C20.0476821,6.39498433 21.0348786,5.34169279 21.0348786,4.13793103 C21.0348786,2.93416928 20.0476821,1.88087774 18.7567329,1.88087774 Z M4.17660044,9.78056426 C2.9615894,9.78056426 1.89845475,10.7586207 1.89845475,11.9623824 C1.89845475,13.2413793 2.9615894,14.2194357 4.17660044,14.2194357 C5.39161148,14.2194357 6.45474614,13.2413793 6.45474614,11.9623824 C6.45474614,10.7586207 5.39161148,9.78056426 4.17660044,9.78056426 Z",
    id: "path-share"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1440,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MyRes_GuestPortal_Landing-@1440",
    transform: "translate(-1328.000000, -18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav/my_res/1440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/system/share",
    transform: "translate(1328.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "share",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-share"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/placeholder-icon",
    mask: "url(#share)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.0373c9896c149eb1c2fb51927a2a809b.svg";
export { ForwardRef as ReactComponent };